export enum AddPartMode {
  InitialGroupAndPart = 'InitialGroupAndPart',
  SubsequentPartForGroup = 'SubsequentPartForGroup',
  FirstPartForGroup = 'FirstPartForGroup',
  SubsequentGroupAndPart = 'SubsequentGroupAndPart',
}
